import React from 'react';

import {
  FolderSharedIcon,
  FolderIcon as FolderIconOriginal,
} from '@gogame/components';

const FolderIcon = ({ isPublic }, { isGroupItem }) =>
  isGroupItem ? (
    isPublic ? (
      <FolderSharedIcon color={'action'} />
    ) : (
      <FolderIconOriginal color={'action'} />
    )
  ) : null;

export default FolderIcon;
